import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function CategoryNavSection() {
  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="px-4 md:px-6 lg:px-10">
        <div className="max-w-7xl mx-auto">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading mb-2">
            漫画<span className="text-primary-500">分类</span>
          </h2>
          <p className="text-sm text-foreground-500 mb-10">
            按分类浏览，快速找到你喜欢的类型
          </p>

          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4">
            {categories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className="group flex items-center gap-3 p-4 md:p-5 rounded-lg bg-background-100 hover:bg-primary-50 transition-colors cursor-pointer"
              >
                <div className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center rounded-lg bg-background-200 group-hover:bg-primary-500 transition-colors">
                  <i className={`${cat.icon} text-foreground-600 group-hover:text-background-50 text-lg md:text-xl transition-colors`}></i>
                </div>
                <div>
                  <h3 className="text-sm md:text-base font-semibold text-foreground-950 group-hover:text-primary-500 transition-colors">
                    {cat.name}
                  </h3>
                  <p className="text-xs text-foreground-400">{cat.count}部</p>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}